
import { useEffect, useState } from 'react';
// import './spiderman.css';
// import { getregister, getregisterfilter , getcaste } from "./../action/user";
import whyeliteLeft from "../../../assests/images/whyelite-left.svg";
import whyeliteRight from "../../../assests/images/whyelite-right.png";
import config from "../../../lib/config";
import { getmyprofile } from "./../../action/user";
import ImageSlider from '../../sidebar/ImageSlider';

function AgentProfile() {

    const [showPopup, setShowPopup] = useState(false);

    const [post, setRegister] = useState([]);
    const [width, setWidth] = useState(window.innerWidth);
    const [height1, setHeight] = useState(window.innerHeight);
    const [profileimg, setprofileimg] = useState([]);
    const [profileimg1, setprofileimg1] = useState([]);
    // const [registerfilter, setRegisterfilters]=useState([]);

    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    });

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    const closeModal = (e) => {
        if (e.target.className === "popup") {
            togglePopup();
        }
    };

    const getUserData = async () => {
        var test = await getmyprofile();
        setRegister(test.userValue);
        // setprofileimg1(test.userValue.userValue.photopath[0])
        if (test.userValue?.photopath.length && test.userValue.photopath[0]) {
            setprofileimg(test.userValue.photopath.map(url => ({
                original: config.API + `/images/user/${url}`,
                thumbnail: config.API + `/images/user/${url}`,
                originalHeight: "200",
                originalWidth: "200",
                thumbnailHeight: "50",
            })))
        }
    }

    function changenumbertojathagam(text) {
        if (text) {
            const tamil_lang = [
                'J',
                'K',
                'L',
                'Mar',
                'Me',
                'Mo',
                'Ra',
                'Sa',
                'Su',
                'Ve',
                'Man',
                'Va'
            ];
            const newarray = text.split("/");
            const final = newarray.map(e => {
                return e = tamil_lang[e - 1];
            });
            return final.join("/");
        } else {
            return "";
        }
    }
    useEffect(() => {
        //logout(history)
        getUserData();
    }, []);


    // const getUserData = async () => {
    // //
    // console.log(filterobj,"fghjfghjfgdjhg");post
    // var test = await getregisterfilter();
    // setRegisterfilters(test.userValue);
    //   
    // console.log(test, "win");

    // }
    // useEffect(() => {
    // //logout(history)
    // getUserData();
    // }, []);
    const [isZoomed, setIsZoomed] = useState(false)
    const handleImageClick = () => setIsZoomed(true);
    const closeZoom = () => setIsZoomed(false);

    // Determine image source
    // const imgSrc = profileimg.length
    //     ? config.API + "/images/user/" + post.photopath[0]
    //     : ("sex" in post && post?.sex === "Male"
    //         ? require('../../../assests/images/man.png')
    //         : require('../../../assests/images/woman.png'));


    return (
        <div className="container container-top">
            <div class="topright-hide" style={{ textAlign: 'left' }}>
                <img src={whyeliteLeft} class="whyelite-left-img" alt="Elite Arrow" />
            </div>
            <div className="textCenter" >
                {post?.membership ? <button className='theri'>{post.membership} Package</button> : null}
            </div>
            <div className="App">
                <button className='kuselan' onClick={togglePopup}>Edit Profile</button>
                {showPopup ? (
                    <div className="popup" onClick={(e) => closeModal(e)}>
                        <div className="popup_inner">
                            <h2 style={{ color: "black", fontWeight: "bold" }}>You can change your details, contact your admin.</h2>
                            <h2 style={{ color: "black", fontWeight: "bold", marginTop: "25px" }}>Call: 96529 66888 </h2>
                            <button className="close" onClick={togglePopup}>
                                Close
                            </button>
                        </div>
                    </div>
                ) : null}
            </div>
            <div className="centerFruit container" >
                <div className="row" style={{ marginTop: '70px' }}>
                    <div className="col-12 col-md-12 mb-3">
                        <div className='dark-beige'>
                            <span className='heading'>
                                <strong>AGENT INFORMATION</strong>
                            </span>
                        </div>
                        <div className="centerFruit container text-uppercase">
                            <div className="row">
                                <div className="col-12 col-md-12 mb-3 border-end">
                                    <table className="AnDroid w-100">
                                        <tbody>
                                            <tr>
                                                <td className="billa" style={{ width: "450px" }}>Name</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post?.mname || "Venkatesh"}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa" style={{ width: "450px" }}>Gender</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post?.sex || "Male"}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa" style={{ width: "450px" }}>Date of Birth</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post?.date ? (post?.date + "/" + post?.month + "/" + post?.year) : "31/10/2000"}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa" style={{ width: "450px" }}>City</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">Madurai</td>
                                            </tr>
                                            <tr>
                                                <td className="billa" style={{ width: "450px" }}>State</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">Tamilnadu</td>
                                            </tr>
                                            <tr>
                                                <td className='billa' style={{ width: "450px" }}>Mobile number</td>
                                                <td className='kuruvi'>:</td>
                                                <td className='alan'>{post?.phone_number || 9854126232}</td>
                                            </tr>
                                            <tr>
                                                <td className='billa' style={{ width: "450px" }}>Address</td>
                                                <td className='kuruvi'>:</td>
                                                <td className='alan'>{post?.address || "Annanagar, Madurai, Tamilnadu"}</td>
                                            </tr>
                                            <tr>
                                                <td className='billa' style={{ width: "450px" }}>Email address</td>
                                                <td className='kuruvi'>:</td>
                                                <td className='alan'>agent@kalayanasapthapadhi.com</td>
                                            </tr>
                                            <tr>
                                                <td className='billa' style={{ width: "450px" }}>ID Proof</td>
                                                <td className='kuruvi'>:</td>
                                                <td className='alan'>Aadhaar</td>
                                            </tr>
                                            <tr>
                                                <td className='billa' style={{ width: "450px" }}>ID Proof No.</td>
                                                <td className='kuruvi'>:</td>
                                                <td className='alan'>8965 3223 6545 8723</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="col-12 col-md-4" style={{ alignContent: 'center' }}>
                        <ImageSlider post={post} config={config} />
                    </div> */}
                </div>
            </div>

            <style jsx>
                {`
                @media (max-width: 425px) {
                    .container-top{
                        margin-top: 60px  !important;
                    }
                }`}
            </style>
        </div>
    )
}

export default AgentProfile;
